import { render, staticRenderFns } from "./ModalityPopup.vue?vue&type=template&id=d484aae0&scoped=true"
import script from "./ModalityPopup.vue?vue&type=script&lang=js"
export * from "./ModalityPopup.vue?vue&type=script&lang=js"
import style0 from "./ModalityPopup.vue?vue&type=style&index=0&id=d484aae0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d484aae0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d484aae0')) {
      api.createRecord('d484aae0', component.options)
    } else {
      api.reload('d484aae0', component.options)
    }
    module.hot.accept("./ModalityPopup.vue?vue&type=template&id=d484aae0&scoped=true", function () {
      api.rerender('d484aae0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/modality/ModalityPopup.vue"
export default component.exports